import { combineReducers } from 'redux'
import Open_Patient_Tab from './Open_Patient_Tab'
import Open_Caregiver_Tab from './Open_Caregiver_Tab'
import Open_Claim_Tab from './Open_Claim_Tab'
import Open_Payment_Tab from './Open_Payment_Tab'
import Open_EncounterMenu_Tab from './Open_EncounterMenu_Tab'
import SidebarActiveTab from './SidebarActiveTab'
import SidebarList from './SidebarList'
import Login from './LoginReducer'
import PracticeIDReducer from './PracticeIDReducer'
import GeneralDropDownsReducer from './GeneralDropDownsReducer'
import Open_Report_Tab from './Open_Report_Tab'
import ClaimRecordReducer from './ClaimRecordReducer'
import PaymentsRecordReducer from './PaymentsRecordReducer'
import EncounterMenuRecordReducer from './EncounterMenuRecordReducer'
import PatientRecordReducer from './PatientRecordReducer'
import CaregiverRecordReducer from './CaregiverRecordReducer'
import SchedulerProviderArrReducer from './SchedulerProviderArrReducer'
import SubmissionCountReducer from './SubmissionCountReducer'
import MainBarActiveTabsReducer from './MainBarActiveTabsReducer'
import AccountReceivablesCountReducer from './AccountReceivablesCountReducer'
import SettingsReducer from './SettingsReducer'
import RolesandRightsReducer from './RolesandRightsReducer'
import GeneralReportReducer from './GeneralReportReducer'
import ReloadGridReducer from './ReloadGridReducer'
import SignalRhubsReducer from './SignalRhubsReducer'
import CodesDropDownReducer from './CodesDropDownReducer'
import BlinkerReducer from './BlinkerReducer'
import SetupActiveTabReducer from './SetupActiveTabReducer'
import ChildCustomViewReducer from './ChildCustomView'
import PaymentDropdownReducer from './PaymentDropdownReducer'
import EncounterNotesDisplaySettingsReducer from './EncounterNotesDisplaySettingsReducer'
import IsUserProviderReducer from './IsUserProviderReducer'
import NoteTypeDDReducer from './NoteTypeDDReducer'
import UserDataReducer from './UserDataReducer'
import PacketDDReducer from './PacketDDReducer'
import ResumeAISessionReducer from './ResumeAISessionReducer'
import ThemeReducer from './ThemeReducer'

const allreducers = combineReducers({
    Login: Login,
    PracticeIDReducer: PracticeIDReducer,
    GeneralDropDownsReducer: GeneralDropDownsReducer,
    SidebarActiveTab: SidebarActiveTab,
    SidebarList: SidebarList,
    Open_Patient_Tab: Open_Patient_Tab,
    Open_EncounterMenu_Tab: Open_EncounterMenu_Tab,
    Open_Caregiver_Tab: Open_Caregiver_Tab,
    Open_Claim_Tab: Open_Claim_Tab,
    Open_Payment_Tab: Open_Payment_Tab,
    // Open_Encounter_Tab: Open_Encounter_Tab,                              
    Open_Report_Tab: Open_Report_Tab,
    ClaimRecordReducer: ClaimRecordReducer,
    PaymentsRecordReducer: PaymentsRecordReducer,
    PatientRecordReducer: PatientRecordReducer,
    EncounterMenuRecordReducer: EncounterMenuRecordReducer,
    CaregiverRecordReducer: CaregiverRecordReducer,
    SchedulerProviderArrReducer: SchedulerProviderArrReducer,
    SubmissionCountReducer: SubmissionCountReducer,
    MainBarActiveTabsReducer: MainBarActiveTabsReducer,
    AccountReceivablesCountReducer: AccountReceivablesCountReducer,
    SettingsReducer: SettingsReducer,
    RolesandRightsReducer: RolesandRightsReducer,
    GeneralReportReducer: GeneralReportReducer,
    ReloadGridReducer: ReloadGridReducer,
    SignalRhubsReducer: SignalRhubsReducer,
    CodesDropDownReducer: CodesDropDownReducer,
    BlinkerReducer: BlinkerReducer,
    SetupActiveTabReducer: SetupActiveTabReducer,
    ChildCustomViewReducer: ChildCustomViewReducer,
    PaymentDropdownReducer: PaymentDropdownReducer,
    EncounterNotesDisplaySettingsReducer: EncounterNotesDisplaySettingsReducer,
    IsUserProvider: IsUserProviderReducer,
    NoteTypeDDReducer: NoteTypeDDReducer,
    UserDataReducer: UserDataReducer,
    PacketDDReducer: PacketDDReducer,
    ResumeAISessionReducer: ResumeAISessionReducer,
    Theme: ThemeReducer,
})

export default (state, action) => allreducers(action.type === 'USER_LOGOUT' ? undefined : state, action);